module.exports = __webpack_public_path__ + "static/img/product7.146f44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product7.png
// module id = 2Bg0
// module chunks = 0